
import { defineComponent, ref } from 'vue';

import FormularioOperacoes from "./forms/FormularioOperacoes.vue";

import OperacoesTable from "./components/OperacoesTable.vue";

import fintailapi from "../api";

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    FormularioOperacoes,
    OperacoesTable
  },
  data() {
    return {
      rows: [],
      data:false,
      current_page: 0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
      toast : useToast()
    };
  },
  methods: {
    getUnico(id:any) {

      fintailapi
        .get(`/operacoes/${id}`)
        .then((response:any) => {
          this.data = response.data
        })
        .catch((error:any) => {

        })
    },
    salvarUnico(veiculo:any) {

        fintailapi
        .put(`/operacoes/${veiculo.id}`, veiculo)
        .then((response:any) => {

          this.data = false
          this.getPaginas(this.current_offset)

        })
        .catch((error:any) => {

        })

    },
    deleteUnico(id:any) {
      fintailapi
        .delete(`/operacoes/${id}`)
        .then((response:any) => {

          this.toast.success("Operação excluída com sucesso");
          this.getPaginas(this.current_offset)

        })
        .catch((error:any) => {
          this.toast.error("Erro ao excluir Operação, tente novamente.");
        })
    },
    searchCall(campo:any, termo:any) {

      fintailapi
        .get(`/operacoes/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response:any) => {
          this.current_offset = 0;
          this.current_page = 0 / 10; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / 10);
          this.rows = response.data.rows;
        })
        .catch((error:any) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
    fecharUnico() {

        this.data = false

    },
    getPaginas(offset:number) {

      
        if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos


        this.current_offset = offset;

        fintailapi
        .get(`/operacoes?offset=${offset}&limit=10`)
        .then((response:any) => {

          this.current_page = offset / 10; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / 10);
          this.rows = response.data.rows;

        
        })
        .catch((error:any) => {



        })

    },
   },
   created() {

      this.getPaginas(0)

   },

});


